import React from 'react';

import { Modal, Button } from 'react-bootstrap';

class CountryAssistanceOECDModal extends React.Component {
  render() {
    const { show, onClose, content } = this.props;

    return (
      <Modal
        show={ show }
        onHide={ onClose }
        className="assistance-table-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Long description</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          { content }
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={ onClose }>
            <small>Close</small>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CountryAssistanceOECDModal;



// WEBPACK FOOTER //
// ./src/components/CountryAssistance/CountryAssistanceOECDModal.js